import { docSignVisualizationService } from '@/services/document-sign-visualization.service';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { unregUserDocService } from '@/services/unregistered-user-document.service';
import { isUnregUserView } from '@/helpers/ui-helper';

export class DocumentSignVisualizationHelper {
  private readonly _batchSize: number = 0;

  constructor() {
    this._batchSize = +((store.getters[_act.SETT_GET_APPSET] || {}).documentVisualizationUpdateFilesBatchSize || 0);
  }

  async update(documentVersionCode: string, documentVersionsFileCodes: Array<string>,
    onProgress?: (total: number, current: number) => void): Promise<boolean> {
    const isBatchOperationEnabled = this._batchSize > 0;

    let files = documentVersionsFileCodes;
    let requestCount = 0;

    if (isBatchOperationEnabled) {
      if (!(files && files.length)) {
        files = (await this._getDocumentFiles(documentVersionCode)) || [];
      }
      requestCount = Math.ceil(files.length / this._batchSize);
    }

    let updateResult = false;
    if (requestCount > 1) {
      let processedCount = 0;
      let totalCount = files.length;
      if (onProgress) {
        onProgress(totalCount, processedCount);
      }
      for (let i = 0; i < requestCount; i++) {
        let filesBatch = files.slice(i * this._batchSize, (i + 1) * this._batchSize);
        if (filesBatch.length > 0) {
          let batchResult = await this._updateDocumentVisualization(documentVersionCode, filesBatch);
          if (!updateResult) {
            updateResult = batchResult;
          }
          if (onProgress) {
            processedCount += filesBatch.length;
            onProgress(totalCount, processedCount);
          }
        }
      }
    } else {
      updateResult = await this._updateDocumentVisualization(documentVersionCode, files);
    }

    return updateResult;
  }

  private _getDocumentFiles(documentVersionCode: string): Promise<Array<string>> {
    if (isUnregUserView()) {
      return unregUserDocService.getDocumentVisualizationFiles(documentVersionCode);
    } else {
      return docSignVisualizationService.getDocumentFiles(documentVersionCode);
    }
  }

  private _updateDocumentVisualization(documentVersionCode: string, files: Array<string>): Promise<boolean> {
    if (isUnregUserView()) {
      return unregUserDocService.updateDocumentVisualization(documentVersionCode, files);
    } else {
      return docSignVisualizationService.updateDocumentVisualization(documentVersionCode, files);
    }
  }
}
